import { Injectable, Injector } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpResponse
} from '@angular/common/http';
import { Observable, throwError as _throw } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { share } from 'rxjs/operators';
import { Router } from '@angular/router';
import { StorageService } from '../services/storage.service';
import { LOGIN_ROUTE } from '../constants/constants';
import { LoadingService } from '@shared/services/loading.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class Interceptor implements HttpInterceptor {
  private translateService!: TranslateService;

  constructor(
    // private loader: LoaderComponent,
    // private toastrService: ToastrService,
    private router: Router,
    private loadingService: LoadingService,
    private storageService: StorageService,
    private injector: Injector
  ) { }

  private getTranslate(): TranslateService {
    if (!this.translateService) {
      this.translateService = this.injector.get(TranslateService);
    }
    return this.translateService;
  }

  isLoginPage(): boolean {
    return this.router.url === LOGIN_ROUTE;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isStaticAsset = request.url.includes('/assets/')
  || request.url.endsWith('.css')
  || request.url.endsWith('.js')
  || request.url.endsWith('.ico')
  || request.url.endsWith('.json'); // include i18n

    if (isStaticAsset) {
      return next.handle(request); // passa tutto senza loader / token / headers
    }

    const skipLoader = request.headers.has('X-Skip-Loader');

    if (skipLoader) {
      request = request.clone({
        headers: request.headers.delete('X-Skip-Loader')
      });
    } else {
      console.log('loadingService show');
      this.loadingService.show();
    }


    const user = this.storageService.getFromLocalOrSessionStorage('user');


    let token: string | null = null;
    if (user) {
      token = user.token;
    }

    if (token) {
      request = request.clone({
        headers: request.headers.set('Authorization', `Bearer ${token}`)
      });
    }

    request = request.clone({
      headers: request.headers.set('Accept', 'application/json')
    });

    return this.makeRequest(request, next, skipLoader);
  }

  makeRequest(request: HttpRequest<any>, next: HttpHandler, skipLoader: boolean): Observable<HttpEvent<any>> {

    const req: Observable<HttpEvent<any>> = next.handle(request).pipe(
      share(),
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          if (request.method !== 'GET') {
            if (request.responseType === 'blob') {
              if (event.body && !event.body.success) {
                console.log('success', event.body);
              } else if (event.body.success === false) {
                console.error('error', event.body.message);
              }
            } else {
              if (event.body && event.body.success) {
                console.log('success', event.body);
              } else if (event.body && !event.body.success) {
                console.error('error', event.body.message);
              }
            }
          }
        }
      }),
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401) {
          this.sessionExpired(err);
        } else if (err.status === 422) {
          if (err && err.error) {
            const errorMessages = Array.isArray(err.error.errors)
              ? '<ul>' + err.error.errors.map((e: string) => `<li>${e}</li>`).join('') + '</ul>'
              : err.error.message;
            console.error('error', errorMessages);
          }
        } else {
          // Generic error
          if (
            err.status == null ||
            err.status == undefined ||
            err.status == 0 ||
            !navigator?.onLine
          ) {
            console.error('error', 'errors.connection_absent');
            /* this.toastrService.error(
              this.translateService.instant('errors.connection_absent'),
              this.translateService.instant('warning')
            ); */
          } else {
            const errorMessage = err.error?.message || 'Errore sconosciuto';
            console.error(errorMessage);
            // this.toastrService.error(errorMessage, this.translateService.instant('generic_error'));
          }
        }
        return _throw(() => err);
      }),
      finalize(() => {
        if (!skipLoader) {
          this.loadingService.hide();
        }
      })
    );

    return req;
  }

  sessionExpired(err: any) {
    localStorage.clear();

    if (err instanceof HttpErrorResponse) {
      try {
        if (!this.isLoginPage()) {
          console.error('errors', this.getTranslate().instant('errors.session_expired'));
          /* this.toastrService.error(
            this.translateService.instant('errors.session_expired'),
            err.statusText
          ); */
        } else {
          console.error('errors', 'errors.access_error')

          /* this.toastrService.error(
            err.error.message,
            this.translateService.instant('errors.access_error')
          ); */
        }
      } catch (e) {
        // this.toastrService.error(this.translateService.instant('errors.not_know'), '');
        console.error('errors', 'errors.not_know')
      } finally {
        setTimeout(() => (window.location.href = window.location.origin + LOGIN_ROUTE), 3000);
      }
    }
  }
}
